// extracted by mini-css-extract-plugin
export default {"price":"SwapMultipleForm_price__ZVVZw"};